<style lang="scss">
$teal: #5bb8b1;
$teal-dark: #2c7d76;
$teal-bg: #e4f3f0;
$dark: #1a1a2e;
$gray: #6c7280;
$font: 'Segoe UI', system-ui, sans-serif;

/* ── List-mode page background ── */
.loc-wrap {
  background: $teal-bg !important;
  font-family: $font;
}

/* Override the global sticky-t-details gray background in list mode */
.loc-wrap .sticky-t-details {
  background: $teal-bg !important;
}

/* ── Heading ── */
.loc-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.loc-back-btn {
  flex-shrink: 0 !important;
  width: 38px !important;
  height: 38px !important;
  border-radius: 50% !important;
  border: 2px solid $teal !important;
  background: #fff !important;
  color: $teal-dark !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  font-size: 13px !important;
  transition: background 0.15s, color 0.15s !important;
  padding: 0 !important;
  outline: none !important;
  box-shadow: 0 2px 8px rgba(91, 184, 177, 0.2) !important;

  &:hover,
  &:focus {
    background: $teal !important;
    color: #fff !important;
    border-color: $teal !important;
    outline: none !important;
  }
}

.loc-heading__title {
  font-size: 20px;
  font-weight: 700;
  color: $teal-dark;
  margin: 0;
  line-height: 1.2;

  @media (min-width: 768px) {
    font-size: 24px;
  }

  @media (min-width: 1024px) {
    font-size: 28px;
  }
}

.loc-heading__sub {
  font-size: 12px;
  color: $gray;
  margin: 3px 0 0;
}

/* ── Search bar ── */
.loc-search {
  display: flex;
  align-items: center;
  background: #fff;
  border: 2px solid $teal;
  border-radius: 10px;
  padding: 0 12px;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(91, 184, 177, 0.10);

  &__icon {
    color: $teal;
    font-size: 17px;
    flex-shrink: 0;
    margin-right: 10px;
  }

  &__input {
    flex: 1;
    height: 48px;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: transparent;
    font-size: 14px;
    font-family: $font;
    color: $dark;
    padding: 0;

    &::placeholder {
      color: #9aaeb0;
    }
  }

  &__clear {
    flex-shrink: 0;
    height: 30px;
    padding: 0 12px;
    border-radius: 8px;
    background: rgba(91, 184, 177, 0.12);
    color: $teal-dark;
    border: none;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    font-family: $font;
    outline: none;

    &:hover {
      background: $teal;
      color: #fff;
    }
  }
}

/* ── Result label ── */
.loc-result {
  font-size: 12px;
  color: #5a7875;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;

  i {
    color: $teal;
  }
}

/* ── Location card (list mode) ── */
.loc-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  cursor: pointer;
  border: 1.5px solid rgba(91, 184, 177, 0.18);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.18s, border-color 0.18s, transform 0.15s;
  font-family: $font;

  &:hover {
    border-color: $teal;
    box-shadow: 0 6px 20px rgba(91, 184, 177, 0.25);
    transform: translateY(-1px);
  }
}

.map-show {
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  margin: auto;

  .select-client {
    border: 2px solid $teal !important;
    background: rgba(91, 184, 177, 0.04) !important;
  }

  .floating-back-map-button {
    @media (max-width: 768px) {
      position: absolute;
      z-index: 9;
      left: 30px;
      top: 20vh;
      text-align: center;

      border-radius: 20px;
      width: 50px;
      height: 50px;
      color: white;
      background: black;

      i {
        font-size: 25px;
        color: white;
        margin-top: 12px;
      }
    }

    @media (min-width: 768px) {
      display: none;
    }
  }

  // &.content{
  //    @media (max-width: 768px) {
  //     padding: 0;
  //     width: 100%;

  //   }
  // }

  .gmap-map {
    width: 100%;
    height: calc(70vh);

    @media (max-width: 768px) {
      top: 0;
      height: calc(35vh);
    }
  }

  .container-fluid {
    @media (max-width: 768px) {
      padding: 0 !important;
      margin: 0 !important;
    }
  }

  .sticky-t-details {

    /* Compiles to: */
    @media (max-width: 768px) {
      display: none;
    }
  }

  .client-data-map-row {
    padding: 10px 20px 0 20px;
    background: white;
    margin-left: 0px;
    border-left: 2px solid rgb(228, 228, 228);
    height: calc(70vh);

    overflow: auto;

    /* padding: 0 20px 0 20px; */
    @media (max-width: 768px) {
      height: inherit;
      margin: auto;
      left: 0;
      padding-top: 20px;
      box-shadow: rgb(0 0 0 / 5%) 0px 6px 24px 0px,
        rgb(0 0 0 / 8%) 0px 0px 0px 1px;
      background: #eef0f8;
      overflow: auto;
      position: inherit;
      position: fixed;
      /* bottom: 0; */
      /* top: 0; */
      // top:40vh;
      bottom: 0;
      height: 50vh;
      padding-bottom: 10px;
      /* top: 44
vh
; */
      right: 0;
    }

    // .row {
    //   @media (max-width: 768px) {
    //     margin-bottom: 44vh;
    //   }
    // }
    .client-data-map-col {
      padding-bottom: 10px;

      @media (max-width: 768px) {
        padding-right: 15px;
        /* background: white; */
        /* border-radius: 57
        border
px
; */
        border: none;
        padding-left: 15px;
        /* border-radius: 57px; */
      }

      .client-data-map-block {
        box-shadow: rgb(0 0 0 / 5%) 0px 6px 24px 0px,
          rgb(0 0 0 / 8%) 0px 0px 0px 1px;

        &:hover {
          box-shadow: rgb(0 0 0 / 5%) 0px 6px 24px 0px,
            rgb(0 0 0 / 8%) 0px 0px 0px 1px;
          border: 2px solid balck;
        }

        background: #f4f4f4;
        // @media (max-width: 768px) {
        //   background: #f4f4f4;
        //   /* border-radius: 57px; */
        // }
      }
    }
  }
}
</style>
<template>
  <section :class="showMap
    ? 'map-show content d-flex flex-column flex-column-fluid'
    : 'loc-wrap content d-flex flex-column flex-column-fluid'
    ">
    <div class="d-flex flex-column-fluid">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-10 col-md-12 col-12 offset-lg-1 offset-0">
            <div class="sticky-t-details">
              <div class="row">
                <div class="col-md-12">
                  <!-- Heading with back -->
                  <div class="loc-heading">
                    <button class="loc-back-btn" @click="goBack()">
                      <i class="fa fa-arrow-left"></i>
                    </button>
                    <div>
                      <h2 class="loc-heading__title">Please enter your Zipcode or City/State and select from the
                        drop-down options to proceed.</h2>
                      <p class="loc-heading__sub">Appointment for {{ getServiceName }}</p>
                    </div>
                  </div>

                  <!-- Teal search bar -->
                  <div class="loc-search">
                    <i class="flaticon2-search-1 loc-search__icon"></i>
                    <GmapAutocomplete @place_changed="setPlace" placeholder="Enter Zipcode, city/state"
                      class="loc-search__input" id="search_address" />
                    <button class="loc-search__clear" @click="clear()">Clear</button>
                  </div>
                </div>
              </div>
              <div class="row" v-if="yourAddress">
                <div class="col-12">
                  <div class="loc-result">
                    <i class="fa fa-map-pin"></i>
                    Results near <strong>{{ yourAddress }}</strong>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-1" v-if="!showMap">
              <div class="col-md-12 order-1 mb-5 text-center" v-if="dataLoading">
                <loading-spinner style="margin-top:20px"> </loading-spinner>
                <h5 class="mt-3">Please wait!</h5>
              </div>
              <div class="col-12 col-md-6 col-lg-4 order-1 mb-3" v-for="(client, index) in clients" :key="index"
                v-show="clients.length > 0 && !dataLoading">
                <!-- <v-service-card :service="service"></v-service-card> -->
                <v-client-card :url="url" :client="client"></v-client-card>
              </div>
              <div class="col-md-12 order-1 mb-5 text-center" v-show="clients.length < 1 && !dataLoading">
                <v-no-record></v-no-record>
              </div>
            </div>
            <div class="row mt-1 " v-else>
              <div class="floating-back-map-button" @click="goBack()">
                <i class="fa fa-arrow-left"></i>
              </div>

              <div class="col-sm-12 col-md-7 col-lg-8 pr-0">
                <gmap-map ref="mapRef" class="gmap-map" :options="{
                  zoomControl: true,
                  mapTypeControl: false,
                  scaleControl: true,
                  streetViewControl: false,
                  rotateControl: true,
                  fullscreenControl: true,
                  disableDefaultUi: false
                }" @dragend="ondragend" v-on:zoom_changed="ondragend" @click="onClick" :center="center"
                  :zoom="zoomLevel">
                  <!-- <GmapCircle
                    :center="center"
                    :radius="radius"
                    :visible="true"
                    :options="{ fillColor: 'blue', fillOpacity: 0.2 }"
                  ></GmapCircle> -->

                  <gmap-marker :icon="{
                    url: require('../../../assets/images/map/svg/black-marker.svg')
                  }" :key="clients.length + 1" :position="{
                    lat: center.lat,
                    lng: center.lng
                  }"></gmap-marker>
                  <gmap-marker :icon="{
                    url: require('../../../assets/images/map/svg/purple-marker.svg')
                  }" @click="selectClient(item.id)" v-for="(item, index) in clients" :key="index" :position="{
                    lat: parseFloat(item.lat),
                    lng: parseFloat(item.long)
                  }"></gmap-marker>
                </gmap-map>
              </div>
              <div class="col-sm-12 col-md-5 col-lg-4 pl-0">
                <div class="client-data-map-row">
                  <div class="row">
                    <div :show="clients.length > 0 && !dataLoading" class="col-md-12 client-data-map-col mb-2"
                      v-for="(client, index) in clients" :key="index" :id="client.id + '_ref_scroll'">
                      <v-client-card :select="selectedId" :url="url" class="client-data-map-block"
                        :client="client"></v-client-card>
                    </div>

                    <div class="col-md-12 order-1 mb-5 text-center" v-show="clients.length < 1 && !dataLoading">
                      <v-no-record :msg="'No locations found within this map.<br> Search for a City/Zip-code or select another region on the map.'
                        "></v-no-record>
                    </div>

                    <div class="col-md-12 order-1 mb-5 text-center" v-if="dataLoading">
                      <loading-spinner style="margin-top:20px">
                      </loading-spinner>
                      <h5 class="mt-3">Please wait!</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-copy-right-footer></v-copy-right-footer>
    </div>
  </section>
</template>
<script>
import vTitle from "@/components/frontend/title";
import vClientCard from "@/components/frontend/clientcard";
import vNoRecord from "@/components/frontend/norecord";
import vCopyRightFooter from "@/components/frontend/copyrightfooter";
import { mapGetters } from "vuex";
import { FETCH_F_CLIENTS } from "@/core/services/store/actions.type";

import loadingSpinner from "@/components/frontend/spinner.vue";

// import Title from '../../components/frontend/title.vue';
export default {
  components: {
    vTitle,
    vClientCard,
    vNoRecord,
    loadingSpinner,
    vCopyRightFooter
  },

  data() {
    return {
      selectedId: 0,
      searchInput: "",
      center: {
        lat: 0,
        lng: 0
      },
      locationMarkers: [],
      locPlaces: [],
      existingPlace: null,
      yourLat: 0,
      youtLong: 0,
      yourAddress: "",
      errMessage: "",
      clients: [],
      icon_size: 22,
      dataLoading: true,
      url: "",
      showMap: false,
      zoomLevel: 0,
      radius: 100,
      c: []
      // zipCode_ci:0,
    };
  },
  mounted() {
    if (this.getServiceName == "") {
      this.$router.push({
        name: "frontend.home",
        params: { slug: this.$route.params.client_slug }
      });
    }
    this.locateGeoLocation();
    this.$nextTick(() => {
      const input = document.getElementById("search_address");
      if (input) {
        input.addEventListener("keydown", this.selectAddressOnEnter);
      }
    });
  },
  beforeDestroy() {
    const input = document.getElementById("search_address");
    if (input) {
      input.removeEventListener("keydown", this.selectAddressOnEnter);
    }
  },
  computed: {
    ...mapGetters(["getClientSlug", "getServiceName", "getServiceProviderData"])
  },
  methods: {
    onClick(e) {
      var jsonLatLng = JSON.parse(JSON.stringify(e)).latLng;

      this.center = jsonLatLng;

      this.displayLocation(true);
    },
    ondragend() {
      this.$refs.mapRef.$mapPromise.then(map => {
        var jsonLatLng = JSON.parse(JSON.stringify(map.getCenter()));
        this.center = jsonLatLng;
        this.displayLocation(true);
      });
    },
    funZoomLevel() {
      this.radius = parseInt(this.radius);
      var scale = this.radius / 620;
      this.zoomLevel = parseInt(16 - Math.log(scale) / Math.log(2));
      this.$refs.mapRef.$mapPromise.then(map => {
        map.panTo(this.center);
      });
    },
    selectClient(id) {
      var _id = id + "_ref_scroll";
      document.getElementById(_id).scrollIntoView({
        behavior: "smooth"
      });
      this.selectedId = id;
    },
    selectAddressOnEnter(e) {
      if (e.key !== "Enter") {
        return;
      }
      // If a suggestion is already highlighted (arrow keys used), let
      // Google's own handler select it via the normal place_changed flow.
      if (document.getElementsByClassName("pac-item-selected").length) {
        return;
      }
      e.preventDefault();
      var address = e.target.value;
      if (!address) {
        return;
      }
      this.$gmapApiPromiseLazy().then(() => {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: address }, (results, status) => {
          if (status === "OK" && results[0]) {
            this.setPlace(results[0]);
          }
        });
      });
    },
    setPlace(place) {
      this.clients = [];

      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      var address = place.formatted_address;
      this.yourAddress = address;
      this.fetchFClients(true);
    },
    clear() {
      document.getElementById("search_address").value = "";
    },
    goBack() {
      if (this.showMap) {
        document.getElementById("search_address").value = "";
        this.clients = [];
        this.showMap = false;
        this.locateGeoLocation();
      } else {
        this.$router.push({
          name: "frontend.home",
          params: { slug: this.$route.params.client_slug }
        });
      }
    },

    initMarker(loc) {
      this.existingPlace = loc;
    },
    displayLocation(flag = false) {
      var request = new XMLHttpRequest();

      var method = "GET";
      var url =
        "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
        this.center.lat +
        "," +
        this.center.lng +
        "&key=" +
        this.getServiceProviderData.key;
      var async = true;

      request.open(method, url, async);
      var that = this;
      // var j = 0;
      // var address = "";

      request.onreadystatechange = function () {
        if (request.readyState == 4 && request.status == 200) {
          var data = JSON.parse(request.responseText);
          if (data.results[0]) {
            var address = data.results[0].formatted_address;
            that.yourAddress = address;
            that.fetchFClients(flag);
          }
        }
      };
      //  that.fetchFClients();

      request.send();
    },

    locateGeoLocation: function () {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.displayLocation();
      });
    },
    fetchFClients(first = false) {
      this.selectedId = 0;
      this.dataLoading = true;
      this.$store
        .dispatch(FETCH_F_CLIENTS, {
          center: this.center,
          slug: this.$route.params.slug,
          client_slug: this.$route.params.client_slug
        })
        .then(data => {
          this.clients = data.data;
          this.radius = data.map_radius * 1.60934 * 1000;
          if (data.data.length > 0) {
            if (first) {
              this.showMap = first;
            }
            this.funZoomLevel();
          }
          this.url = data.url;
          this.dataLoading = false;
        })
        .catch(() => {
          this.dataLoading = false;
        });
    }
  }
};
</script>
